import { DatePicker, Form } from 'antd';
import moment from 'moment';

export function InputDate({
  name = '',
  label = '',
  type = 'single',
  required = false,
  showTime = false,
  onChange,
  inputProps,
}) {
  return (
    <Form.Item name={name} label={label} rules={[{ required, message: `กรุณาเลือก${label}` }]}>
      {type === 'single' ? (
        <DatePickerComponent
          showTime={showTime}
          style={{ width: '100%' }}
          placeholder={`เลือก${label}`}
          onChange={onChange}
          {...inputProps}
        />
      ) : (
        <DateRangePickerComponent
          showTime={showTime}
          style={{ width: '100%' }}
          placeholder={['วันที่เริ่ม', 'วันที่สิ้นสุด']}
          onChange={onChange}
          {...inputProps}
        />
      )}
    </Form.Item>
  );
}

function DatePickerComponent(props) {
  const forceValues = props?.value ? moment(props?.value) : null;

  const thaiYearFormat = (value) => {
    return value.format(`DD MMMM ${value.eraYear() + 543}${props.showTime ? ' HH:mm:ss' : ''}`);
  };

  return <DatePicker {...props} value={forceValues} format={thaiYearFormat} />;
}

function DateRangePickerComponent(props) {
  const forceValues = props?.value ? [moment(props?.value[0]), moment(props?.value[1])] : null;

  const thaiYearFormat = (value) => {
    return value.format(`DD MMMM ${value.eraYear() + 543}${props.showTime ? ' HH:mm:ss' : ''}`);
  };

  return <DatePicker.RangePicker {...props} value={forceValues} format={thaiYearFormat} />;
}
